import React, {useEffect} from 'react';
import { Link } from "react-router-dom";
import { BottomAcc, LockAcc, NewZoom, TopAcc, Zoom } from "../../../ui/icons";
import {useDispatch, useSelector} from "react-redux";
import {getCourseById} from "../../../store/courseSlice";
import {getSeminar} from "../../../store/seminarsSlice";

const Seminars = () => {
    const {seminar} = useSelector((state) => state.seminar);
    const dispatch = useDispatch()
    useEffect(() => {
       dispatch(getSeminar());
    }, [dispatch]);
    return (
        <>
        {
            seminar.map(item => (
                <div className="flex flex-col gap-4  p-[16px]" style={{borderWidth: '0.5px', borderColor: '#e9e9e9'}}>
                    <div className="sm:flex lg:flex justify-between ">
                        <div className="flex items-center gap-2 ">
                            <LockAcc/>
                            <p className="font-semibold ">{item.title}</p>
                        </div>
                        <div className="flex gap-5 items-center sm:pt-0 pt-4 sm:pl-0 pl-7">
                            <p>{item.date}</p>
                            <div className="rounded-[50%] w-1 h-1 bg-[#1E1E1E4D]">

                            </div>
                            <ul>
                                <li>
                                    <p>{item.time}</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div key={item.id} className="flex justify-between items-center pl-8">
                        <p className="text-xs sm:text-sm">{item.teacher?.teacher_name}</p>
                        <Link to={item?.link}
                              className="flex items-center gap-2 cursor-pointer text-lg font-semibold     "><NewZoom/></Link>
                    </div>

                </div>
            ))
        }
        </>
    );
};

export default Seminars;
